import React from 'react';

import { BONUS_FIELDS } from './constants';

import {
  CircularProgress,
  IconButton,
  TableCell,
  Tooltip,
} from '@material-ui/core';
import './Bonus.css';
import { Layout } from '../global/Table/TablePageHelpers/LayoutObject';
import TablePage from '../global/Table/TablePage';
import TwoStepDelete from '../global/subcomponents/twoStepDelete/TwoStepDelete';
import PhotoIcon from '@mui/icons-material/Photo';

class BonusTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteId: null,
    };
  }

  getBonusTableHeaders = () => {
    let headers = [];
    BONUS_FIELDS.forEach((headCell) => {
      headers.push(
        Layout.columnHead(headCell.label, headCell.id, headCell.align)
      );
    });
    headers.push(Layout.columnHead(null, null));
    return headers;
  };

  tableBonusRow = (data) => {
    return (
      <React.Fragment>
        <TableCell></TableCell>
        <TableCell className="table-cell-left">
          {data?.firstName + ' ' + data?.lastName + ' (' + data?.tagId + ')'}{' '}
        </TableCell>
        <TableCell className="table-cell-left">{data?.bonusName}</TableCell>
        <TableCell className="table-cell-left">{data?.specify}</TableCell>
        <TableCell className="table-cell-left">{data?.machine}</TableCell>
        <TableCell className="table-cell-left">{data?.bonusAmount}</TableCell>
        <TableCell className="table-cell-left">
          <Tooltip title="Preview Bonus Image">
            <IconButton
              aria-label="Bonus Image"
              onClick={() => {
                this.props.handleEditBonusRow(data?.photo);
              }}
            >
              <PhotoIcon />
            </IconButton>
          </Tooltip>
        </TableCell>

        <TwoStepDelete
          rowId={data?.bonusId}
          handleDelete={(rowIdToDelete) =>
            this.props.deleteBonus({
              bonusId: data?.bonusId,
              userId: this.props.userInfo.userId,
              locationId: this.props.userInfo.selectedLocationId,
            })
          }
          deleteId={this.state.deleteId}
          setDeleteId={(newDeleteId) =>
            this.setState({ deleteId: newDeleteId })
          }
        />
      </React.Fragment>
    );
  };

  searchBonusStrings = (data) => {
    return [data.firstName, data.LastName, data.tagId];
  };

  render() {
    const bonus = this.props.bonus || [];
    const totalBonus = bonus.reduce(
      (sum, item) => sum + parseFloat(item.bonusAmount),
      0
    );

    return (
      <div>
        {!this.props.isPreviewImage ? (
          <>
            <div
              style={{
                backgroundColor: this.props.userInfo?.employeeColor
                  ? this.props.userInfo?.employeeColor
                  : '#011217',
                color: 'white',
                padding: '16px',
                textAlign: 'center',
                fontWeight: 'bold',
                marginTop: '16px',
              }}
            >
              Total Bonus ({totalBonus})
            </div>
            <TablePage
              tableName="bonus"
              tableRows={this.props.claimBonus}
              tableColumnHeads={this.getBonusTableHeaders()}
              tableRow={this.tableBonusRow}
              paginationText="Results"
              searchStrings={this.searchBonusStrings}
              defaultSortBy="name"
            />
          </>
        ) : (
          <>
            {this.props.image ? (
              <img
                src={this.props.image}
                alt="Customer"
                className="responsive-image-full-screen"
              />
            ) : (
              <div className="loading-indicator">
                <CircularProgress />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default BonusTable;
